import { render, staticRenderFns } from "./forwardReport.vue?vue&type=template&id=237d8555"
import script from "./forwardReport.vue?vue&type=script&lang=js"
export * from "./forwardReport.vue?vue&type=script&lang=js"
import style0 from "./forwardReport.vue?vue&type=style&index=0&id=237d8555&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports